import {
  CodeRounded,
  SchoolRounded,
  DataObjectRounded,
  DomainVerificationRounded,
} from "@mui/icons-material";

export const devWorkInfo = [
  {
    tooltipTitle: "تعداد ساعت های  کدزنی:)",
    icon: <CodeRounded />,
    total: 1650,
    color: "lightcoral",
  },
  {
    tooltipTitle: "تعداد واحد  های  پاس شده ",
    icon: <SchoolRounded />,
    total: 36,
    color: "lightskyblue",
  },
  {
    tooltipTitle: "تعداد پروژه های من",
    icon: <DataObjectRounded />,
    total: 6,
    color: "lightslategray",
  },
  {
    tooltipTitle: "تعداد پروژه های به پایان رسیده",
    icon: <DomainVerificationRounded />,
    total: 6,
    color: "lightseagreen",
  },
];

export const devEdu = [
  {
    year: "1401-1402",
    cert: "دیپلم",
    major: "شاخه نظری رشته ریاضی",
    place: "دبیرستان شهید ملک ثابت یزد",
  },
  {
    year: "1402",
    cert: "کارشناسی",
    major: "در حال تحصیل در رشته مهندسی کامپیوتر",
    place: "دانشگاه علم و صنعت ایران",
  },
];
export const devExp = [
  {
    time: "ترم1 دانشگاه ",
    projectTitle: "پیاده سازی یک  مینی  گیم در ترمینال با  زبان  C++",
  },
  {
    time: "ترم 2 دانشگاه",
    projectTitle: "پیاده سازی  اپلیکیشن کاربردی حسابداری من با  زبان پایتون",
  },
  {
    time: "ترم 1 و2  دانشگاه",
    projectTitle: " ساخت چندین قالب استاتیک ساده سایت با  html css",
  },
];
